// extracted by mini-css-extract-plugin
module.exports = {"center":"TextCenter_center__3VJXs"};